module.exports = __webpack_public_path__ + "media/images/athletes/3139-6ed67ff6347dd5ddb228b7081ee5f01c.png";